import { cn } from "@/lib/utils"

interface FormSectionHeaderProps {
  number: string
  title: string
  className?: string
}

const FormSectionHeader = ({ number, title, className }: FormSectionHeaderProps) => (
  <div className={cn("mb-8 flex items-center gap-5", className)}>
    <div className="flex h-10 w-14 items-center justify-center border-l-4 border-primary bg-muted/30 font-mono text-sm font-black tracking-widest text-primary shadow-sm">
      [{number}]
    </div>
    <h3 className="font-display text-3xl uppercase tracking-widest text-foreground md:text-4xl">
      {title}
    </h3>
  </div>
)

export { FormSectionHeader }
